import React, { Component } from 'react';
import { connect } from 'react-redux';
import fileDownload from 'js-file-download';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faFileExport,
    faSearch,
    faEdit,
    faEye,
    faBan,
} from '@fortawesome/free-solid-svg-icons';
import { NavLink } from 'react-router-dom';
import {
    Form, Button, DatePicker, Col, Icon, message, Popconfirm, Statistic, Progress, Tag, Pagination, Modal
    , Table, Spin, Input, Checkbox
} from 'antd';
import Card from './Card';
import Row from './Row';
import Spacer from './Spacer';
import ServerSideTable from './DeliveryLopCard';
import Select from './Select';
import {
    fetchPickupList,
    fetchTransmittalList,
    deleteDispatch,
    setPackageRemarks,
    createTransferCallout,
    fetchTransferCallout,
    fetchOptions,
    fetchOptionsLike,
    fetchTransferPerformanceList,
} from '../pages/ducks';
import { filter } from 'lodash';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
export class TransferPerformanceList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            options: {
                outsource: [],
                port_code: [],
                courier: [],
                statuses: [{ value: 'delivery_successful', label: 'delivery_successful' }, { value: 'first_delivery_attempt', label: 'first_delivery_attempt' }, { value: 'redelivery_attempt', label: 'redelivery_attempt' }, { value: 'failed_delivery_return', label: 'failed_delivery_return' }, { value: 'redelivery_attempt_failed', label: 'redelivery_attempt_failed' }, { value: 'first_attempt_failed', label: 'first_attempt_failed' }],
            },
            runsheetModalVisible: false,
            runsheetData: null,
            noDocumentsShow: false,
            documentPackage: null,
            calloutDetailModalVisible: false,
            packageDocumentNote: "",
            forIrRemark: "",
            isIr: false,
            selectedPortCode: null,
            selectedOutSource: null,
            selectedStatus: null,
            selectedCourier: null,
            showDocumentValiditySuccess: false,
            selectedDocuments: [], // to hold the URLs of the clicked package
            transferList: {
                rows: [],
                total: 0,
                pages: 0,
                stats: {},
                filter: [],
            },
            callOutList: {
                rows: [],
                page: 0,
                total: 0,
                filter: [],
                sorted: [],
                pageSize: 10,
            },
            currentFilters: {
                page: 0,
                pageSize: 10,
                filter: [],
                sorted: [],
            },
            isCallOutLoading: false,
            isFetching: {
                location: false,
                outsource: false
            },
            dateFilter: [],
            isFetching: false,
            resTablePayload: {},
            isDisabledButton: false,
            current: 0,
            page: 0,
            pageSize: 10,
            getStats: 0,
            hasMore: true,
        };
        this.selectOptions = ['outsource', 'port_code', 'courier'];
        this.onFetchData = this.onFetchData.bind(this);
        this.onFetchCallOutData = this.onFetchCallOutData.bind(this);
        this.searchOption = this.searchOption.bind(this);
        this.datePickerFilterHandler = this.datePickerFilterHandler.bind(this);
        this.applyDateFilterHandler = this.applyDateFilterHandler.bind(this);
        this.cancelHandler = this.cancelHandler.bind(this);
        this.inArray = this.inArray.bind(this);
    }

    onFetchCallOutData = (tableState) => {
        const { doFetchTransferCallout } = this.props;
        const { currentFilters } = this.state;

        const callOutParams = {
            page: tableState.page,
            pageSize: tableState.pageSize,
            filter: tableState.filtered || [],
            sorted: tableState.sorted || [],

            first_name: currentFilters.first_name,
            last_name: currentFilters.last_name,
            dh_id: currentFilters.dh_id,
        };

        this.setState({
            isCallOutLoading: true,
            currentFilters: callOutParams,
        });

        doFetchTransferCallout(callOutParams).then((action) => {
            this.setState(prev => ({
                callOutList: {
                    ...prev.callOutList,
                    rows: action.payload.data.rows,
                    pages: action.payload.data.pages,
                    total: action.payload.data.total,
                    page: tableState.page,
                },
                isCallOutLoading: false,
            }));
        });
    };
    openRunsheetModal = (data) => {
        console.log(data);
        this.setState({
            runsheetModalVisible: true,
            runsheetData: data
        });
    };
    closeRunsheetModal = () => {
        this.setState({
            runsheetModalVisible: false,
            runsheetData: null
        });
    };
    openCalloutDetailModal = (data) => {
        const { doFetchTransferCallout } = this.props;
        const packages = data.packages && data.packages.length > 0 ? data.packages[0] : {};
        const callOutBy = {
            first_name: packages.firstname,
            last_name: packages.lastname,
            dh_id: packages.dh_id,
        };
        const currentFilters = {
            ...this.state.currentFilters,
            ...callOutBy,
        };
        this.setState({
            calloutDetailModalVisible: true,
            forIrRemark: "",
            isIr: false,
            runsheetData: data,
            currentFilters,
            callOutList: {
                rows: [],
                total: 0,
                pageSize: 10,
            },
        });
        doFetchTransferCallout(currentFilters).then((action) => {
            this.setState({
                callOutList: {
                    rows: action.payload.data.rows,
                    pages: action.payload.data.pages,
                    total: action.payload.data.total,
                },
                isCallOutLoading: false,
            });
        });

    };
    closeCalloutDetailModal = () => {
        this.setState({
            calloutDetailModalVisible: false,
            forIrRemark: "",
            isIr: false,
            runsheetData: null,
            callOutList: {
                rows: [],
                total: 0,
                pageSize: 10,
            },
            currentFilters: {
                dh_id: "",
            },
            isCallOutLoading: false,
        });
    };
    setPackageValidity(validity, note) {
        const { dosetPackageRemarks } = this.props;
        if (note.length > 0) {
            validity = validity + " " + note;
        }
        const params = {
            tracking_number: this.state.documentPackage.tracking_number,
            remarks: validity
        };
        dosetPackageRemarks(params).then((action) => {
            const code = action.payload.data.code;
            if (code == 200) {
                this.state.documentPackage.remarks = validity;
                this.setState({
                    runsheetData: { ...this.state.runsheetData },
                    packageDocumentNote: '',
                    showDocumentValiditySuccess: true,
                });
            }
        });
    }
    handleSaveIr = (forIrRemark, isIr) => {
        const { doCreateTransferCallout, doFetchTransferCallout } = this.props;
        const { currentFilters } = this.state;
        if (forIrRemark.length === 0) {
            message.warning('Please enter remarks');
            return;
        }
        const remark = isIr ? `For IR - ${forIrRemark}` : forIrRemark;
        const params = {
            is_ir: isIr,
            remarks: remark,
            first_name: this.state.runsheetData.packages[0].firstname,
            last_name: this.state.runsheetData.packages[0].lastname,
            contact_number: this.state.runsheetData.packages[0].mobile_no,
            dh_id: this.state.runsheetData.packages[0].dh_id,
        };
        doCreateTransferCallout(params).then((action) => {
            const code = action.payload.data.code;
            const message = action.payload.data.message;
            this.setState({ isCallOutLoading: true });
            if (code == 200) {
                message.success(message);
                doFetchTransferCallout(currentFilters).then((action) => {
                    this.setState(prev => ({
                        callOutList: {
                            ...prev.callOutList,
                            rows: action.payload.data.rows,
                            pages: action.payload.data.pages,
                            total: action.payload.data.total,
                        },
                        isCallOutLoading: false,
                        forIrRemark: "",
                        isIr: false,
                    }));
                });
            }
        });

    };
    searchOption(type, e) {
        const { doFetchOptionsLike } = this.props;

        this.setState({
            isFetching: true,
        });

        doFetchOptionsLike(type, e).then((action) => {
            this.setState(prev => ({
                isFetching: { ...prev.isFetching, [type]: true }
            }));
            this.setState(prevState => ({
                options: {
                    ...prevState.options,
                    [type]: action.payload.data.slice(0, 50),
                },
                isFetching: { ...prevState.isFetching, [type]: false }
            }));
        });
    }
    onFetchData(state, instance) {
        let { dateFilter, transferList, selectedOutSource, selectedPortCode, selectedStatus, selectedCourier } = this.state;

        const {
            doFetchTransferPerformanceList,
            dofetchOptions,
            dofetchOptionsLike,
            typeDispatch,
        } = this.props;

        const dispatchType = [{ id: 'type', value: typeDispatch }];
        const osFilter = [{ id: 'outsource', value: selectedOutSource }];
        const portCodeFilter = [{ id: 'port_code', value: selectedPortCode }];
        const statusFilter = [{ id: 'status', value: selectedStatus }];
        const courierFilter = [{ id: 'courier', value: selectedCourier }];

        if (dateFilter.length == 0) {
            const today = new Date();
            const formattedDate = today.toISOString().split('T')[0]; //
            dateFilter = [{ id: "date", value: formattedDate }];
        }
        const params = {
            exportPerformance: false,
            exportFd: false,
            exportCallOut: false,
            page: state.page,
            pageSize: state.pageSize,
            filter: [...state.filtered, ...dateFilter, ...dispatchType, ...osFilter, ...portCodeFilter, ...statusFilter, ...courierFilter],
            sorted: state.sorted,
            getStats: state.getStats
        };
        this.setState({ isFetching: true });

        const request = doFetchTransferPerformanceList(params);

        request.then((action) => {

            const newRows = action.payload.data.rows;
            const newStats = action.payload.data.stats;
            const newFilter = action.payload.data.filter;
            this.setState(prev => ({
                transferList: {
                    rows: [...prev.transferList.rows, ...newRows],
                    total: action.payload.data.total,
                    pages: action.payload.data.pages,
                    stats: newStats != null ? newStats : prev.transferList.stats,
                    filter: newFilter != null ? newFilter : prev.transferList.filter
                },
                isFetching: false,
                page: state.page,
                getStats: 0,
                hasMore: newRows.length > 0
            }));

        });

    }
    componentDidMount() {
        const {
            doFetchOptions,
        } = this.props;
        const selectOptions = this.selectOptions;
        this.onFetchData({
            page: 0,
            pageSize: this.state.pageSize,
            filtered: [],
            sorted: [],
            getStats: 1
        });

        window.addEventListener("scroll", this.handleScroll);
        Object.keys(selectOptions).forEach((key) => {
            doFetchOptions(selectOptions[key]).then((action) => {
                this.setState(prevState => ({
                    options: {
                        ...prevState.options,
                        [selectOptions[key]]: (selectOptions[key] === 'outsource' ? action.payload.data : action.payload.data.slice(0, 50)),
                    },
                }));
            });
        });
    }
    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll);
    }
    handleScroll = () => {

        const { isFetching, hasMore, page, pageSize, options } = this.state;

        if (isFetching || !hasMore) return;

        if (
            window.innerHeight + document.documentElement.scrollTop
            >= document.documentElement.offsetHeight - 200
        ) {

            const nextPage = page + 1;

            this.onFetchData({
                page: nextPage,
                pageSize: pageSize,
                filtered: [],
                sorted: []
            });

        }

    };
    inArray(userId, ids) {
        var id = ids.length;
        for (var i = 0; i < id; i++) {
            if (ids[i] == userId) return true;
        }
        return false;
    }

    exportFileList() {
        const { dateFilter, resTablePayload } = this.state;
        const { doFetchTransferPerformanceList, dispatchExportName } = this.props;

        this.setState({
            isDisabledButton: true,
            isFetching: true,
        });

        const params = {
            export: true,
            page: resTablePayload.page,
            pageSize: resTablePayload.pageSize,
            filter: [...resTablePayload.filter, ...dateFilter],
            sorted: resTablePayload.sorted,
        };

        doFetchTransferPerformanceList(params).then((res) => {
            const newBlob = new Blob([res.payload.data]);
            fileDownload(newBlob, `${dispatchExportName}-Dispatch.csv`);
            this.setState({
                isDisabledButton: false,
                isFetching: false,
            });
        });
    }

    exportPerformance() {
        const { transferList, } = this.state;
        const { doFetchTransferPerformanceList } = this.props;
        this.setState({
            isDisabledButton: true,
            isFetching: true,
        });
        const params = {
            exportPerformance: true,
            exportFd: false,
            exportCallOut: false,
            page: transferList.page,
            filter: [...transferList.filter],
        };

        doFetchTransferPerformanceList(params).then((res) => {
            const newBlob = new Blob([res.payload.data]);
            fileDownload(newBlob, `delivery_performance.csv`);
            this.setState({
                isDisabledButton: false,
                isFetching: false,
            });
        });
    }

    exportCallOut() {
        const { transferList, } = this.state;
        const { doFetchTransferPerformanceList } = this.props;
        this.setState({
            isDisabledButton: true,
            isFetching: true,
        });
        const params = {
            exportPerformance: false,
            exportFd: false,
            exportCallOut: true,
            page: transferList.page,
            filter: [...transferList.filter],
        };

        doFetchTransferPerformanceList(params).then((res) => {
            const newBlob = new Blob([res.payload.data]);
            fileDownload(newBlob, `delivery_performance_callout.csv`);
            this.setState({
                isDisabledButton: false,
                isFetching: false,
            });
        });
    }

    datePickerFilterHandler(dateStrings) {
        const newDate = dateStrings;
        const formatDate = format(newDate, 'YYYY-MM-DD');
        this.setState({
            dateFilter: formatDate !== 'Invalid Date'
                ? [{ id: 'date', value: formatDate }]
                : [],
        });
    }

    applyDateFilterHandler() {
        const { dateFilter } = this.state;

        const params = {
            page: 0,
            pageSize: 10,
            filtered: [],
            sorted: [],
            getStats: 1,
        };
        if (dateFilter.length > 0 && dateFilter[0].value) {

            this.setState({
                transferList: {
                    rows: [],
                    total: 0,
                    pages: 0
                },
            }, () => {
                this.onFetchData(params);
            });

        } else {
            message.warning('Please select date!');
        }
    }

    cancelHandler(dispatchId) {
        const { resTablePayload } = this.state;
        const { doDeleteDispatch } = this.props;
        const params = {
            export: false,
            page: resTablePayload.page,
            pageSize: resTablePayload.pageSize,
            filtered: resTablePayload.filter,
            sorted: resTablePayload.sorted,
        };
        doDeleteDispatch(dispatchId)
            .then(() => {
                this.onFetchData(params);
                message.success('Successfully deleted dispatch!');
            })
            .catch(() => {
                message.error('Something went wrong, please try again later.');
            });
    }

    render() {
        const { transferList, isFetching, isDisabledButton, current, options, callOutList, isCallOutLoading } = this.state;
        const {
            fetchText,
            isCustomerMerchantPickUp,
            urlEndpoint,
            isTransmittal,
            user,
        } = this.props;
        const { RangePicker } = DatePicker;
        return (
            <div className="transferList">
                <Card title="List Filter">
                    <Row>
                        <Col xs={24} sm={12} lg={5}>
                            <Form.Item label="Port Code"
                                initialValue={"ABPLN"}
                            >
                                {(
                                    <Select
                                        style={{ width: '100%' }}
                                        allowClear
                                        showSearch
                                        loading={isFetching.port_code}
                                        filterOption={false}
                                        onSearch={e => this.searchOption('port_code', e)}
                                        options={options.port_code}
                                        placeholder="Select port code"
                                        name="port_code"
                                        onChange={(value) => {
                                            this.setState({ selectedPortCode: value }); // store in state if needed
                                        }}
                                    />
                                )}
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} lg={5}>
                            <Form.Item label="Outsource Group"
                            >
                                {(
                                    <Select
                                        style={{ width: '100%' }}
                                        allowClear
                                        showSearch
                                        loading={isFetching.outsource}
                                        filterOption={false}
                                        onSearch={e => this.searchOption('outsource', e)}
                                        options={options.outsource}
                                        placeholder="Select outsource group"
                                        name="outsource"
                                        onChange={(value) => {
                                            this.setState({ selectedOutSource: value }); // store in state if needed
                                        }}
                                    />
                                )}
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} lg={5}>
                            <Form.Item label="Status"
                            >
                                {(
                                    <Select
                                        style={{ width: '100%' }}
                                        allowClear
                                        showSearch
                                        filterOption={false}
                                        options={options.statuses}
                                        placeholder="Select status"
                                        name="status"
                                        onChange={(value) => {
                                            this.setState({ selectedStatus: value }); // store in state if needed
                                        }}
                                    />
                                )}
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} lg={5}>
                            <Form.Item label="Courier"
                            >
                                {(
                                    <Select
                                        style={{ width: '100%' }}
                                        allowClear
                                        showSearch
                                        loading={isFetching.courier}
                                        filterOption={false}
                                        onSearch={e => this.searchOption('courier', e)}
                                        options={options.courier}
                                        placeholder="Select courier"
                                        name="courier"
                                        onChange={(value) => {
                                            this.setState({ selectedCourier: value }); // store in state if needed
                                        }}
                                    />
                                )}
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} lg={4}>
                            <Form.Item label="Date Filter">
                                <DatePicker
                                    placeholder="Select date"
                                    onChange={e => this.datePickerFilterHandler(e)}
                                    style={{ width: '100%' }}
                                />,
                            </Form.Item>
                        </Col>

                    </Row>
                    <Row>
                        <Col>
                            <Button
                                type="primary"
                                htmlType="submit"
                                block
                                onClick={this.applyDateFilterHandler}
                            >
                                <Icon viewBox="0 0 1024 1024">
                                    <FontAwesomeIcon icon={faSearch} fixedWidth />
                                </Icon>
                                Search
                            </Button>
                        </Col>
                    </Row>
                    <br></br><br></br><br></br>
                    <Row gutter={24} justify="center" style={{ marginTop: 20 }}>
                        <Col xs={24} md={8} style={{ textAlign: "center" }}>
                            <Statistic
                                title="Total Couriers"
                                value={transferList.stats ? transferList.stats.couriers : 0}
                                valueStyle={{ fontSize: 32 }}
                            />
                        </Col>

                        <Col xs={24} md={8} style={{ textAlign: "center" }}>
                            <Statistic
                                title="Total Deliveries"
                                value={transferList.stats ? transferList.stats.total : 0}
                                suffix={transferList.stats ? transferList.stats.total > 0 ? Math.round(((transferList.stats.total_completed / transferList.stats.total) * 100)) + "%" : "0%" : "0%"}
                                valueStyle={{ fontSize: 32 }}
                            />
                        </Col>

                        <Col xs={24} md={8} style={{ textAlign: "center" }}>
                            <Statistic
                                title="Total Pending"
                                value={transferList.stats ? transferList.stats.total_pending : 0}
                                suffix={transferList.stats ? transferList.stats.total > 0 ? Math.round(((transferList.stats.total_pending / transferList.stats.total) * 100)) + "%" : "0%" : "0%"}
                                valueStyle={{ fontSize: 32 }}
                            />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 30, marginBottom: 10 }}>
                        <Col span={24}>
                            <div style={{
                                display: 'flex',
                                width: '100%',
                                height: '24px',
                                backgroundColor: '#bdc3c7', // Default Pending color
                                borderRadius: '4px',
                                overflow: 'hidden'
                            }}>
                                {/* Successful Segment (Green) */}
                                <div style={{
                                    width: transferList.stats ? transferList.stats.total > 0 ? `${(transferList.stats.total_completed / transferList.stats.total) * 100}%` : "0%" : "0%",
                                    backgroundColor: '#72c424'
                                }} />
                                {/* Failed Segment (Orange) */}
                                <div style={{
                                    width: transferList.stats ? transferList.stats.total > 0 ? `${(transferList.stats.total_pending / transferList.stats.total) * 100}%` : "0%" : "0%",
                                    backgroundColor: '#ed4f27'
                                }} />

                                {/* The remaining space automatically shows the background (Pending/Grey) */}
                            </div>
                        </Col>
                    </Row>
                    <Row gutter={24} justify="center" style={{ marginTop: 15, fontSize: 14 }}>
                        <Col span={10} style={{ textAlign: "center" }}>
                            <span style={{ color: '#72c424', fontSize: 18 }}>●</span> {transferList.stats ? transferList.stats.total_completed : 0} Successful {transferList.stats ? transferList.stats.total > 0 ? Math.round(((transferList.stats.total_completed / transferList.stats.total) * 100)) + "%" : "0%" : "0%"}
                        </Col>
                        <Col span={10} style={{ textAlign: "center" }}>
                            <span style={{ color: '#ed4f27', fontSize: 18 }}>●</span> {transferList.stats ? transferList.stats.total_pending : 0} Pending {transferList.stats ? transferList.stats.total > 0 ? Math.round(((transferList.stats.total_pending / transferList.stats.total) * 100)) + "%" : "0%" : "0%"}
                        </Col>
                    </Row>
                </Card>
                <Spacer />{
                }

                <Card
                >

                    {transferList.rows.length > 0 && (
                        <Row gutter={[16, 16]}>
                            <Col style={{ marginBottom: 16 }} xs={24} sm={12} lg={8}>
                                <Button
                                    block
                                    onClick={() => this.exportPerformance()}
                                    disabled={isDisabledButton}
                                    type="primary"
                                >
                                    <Icon viewBox="0 0 1024 1024">
                                        <FontAwesomeIcon icon={faFileExport} fixedWidth />
                                    </Icon>
                                    Export Performance
                                </Button>
                            </Col>

                            <Col style={{ marginBottom: 16 }} xs={24} sm={12} lg={8}>
                                <Button
                                    block
                                    disabled={isDisabledButton}
                                    onClick={() => this.exportCallOut()}
                                    type="primary"
                                >
                                    <Icon viewBox="0 0 1024 1024">
                                        <FontAwesomeIcon icon={faFileExport} fixedWidth />
                                    </Icon>
                                    Export Callout
                                </Button>
                            </Col>
                        </Row>
                    )}
                    <div className="TransferCards" style={{ padding: '20px 0' }}>
                        {transferList.rows.map((row, index) => (
                            <Card
                                key={row.dh_id || row.id}
                                style={{ marginBottom: 16, borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}
                                actions={[
                                    <NavLink to={`${urlEndpoint}/${isCustomerMerchantPickUp ? row.ph_id : row.dh_id}`}>
                                        <Button type="link"><FontAwesomeIcon icon={faEye} /> View</Button>
                                    </NavLink>,
                                    (row.status === 'new' || isCustomerMerchantPickUp) && (
                                        <NavLink to={`${urlEndpoint}/edit/${isCustomerMerchantPickUp ? row.ph_id : row.dh_id}`}>
                                            <Button type="link"><FontAwesomeIcon icon={faEdit} /> Edit</Button>
                                        </NavLink>
                                    )
                                ].filter(Boolean)}
                            >
                                <Card
                                    style={{
                                        borderRadius: 8,
                                        marginBottom: 16
                                    }}
                                >
                                    <Row align="middle" gutter={16}>

                                        {/* Driver Info */}
                                        <Col span={5}>
                                            <div style={{ fontWeight: 600, color: "#1677ff" }}>
                                                {row.packages[0].firstname + " " + row.packages[0].lastname}
                                            </div>{row.packages[0].mobile_no}
                                            <br/>
                                            <b>Van #: {row.packages[0].vehicle_name}</b>
                                            <div style={{ fontSize: 12, color: "#888" }}>
                                                {row.stats.total > 0 ? Math.round(row.stats.completed / row.stats.total * 100) : 0}% completed of {row.stats.total}
                                            </div>
                                        </Col>

                                        {/* Button */}
                                        <Col span={3} style={{ position: "relative", zIndex: 10 }}>
                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                <Button type="primary" ghost size="small" style={{ marginBottom: 8 }}
                                                    onClick={() => this.openRunsheetModal(row)}

                                                >
                                                    Transfer Details
                                                </Button>

                                                <Button type="danger" ghost size="small"
                                                    onClick={() => this.openCalloutDetailModal(row)}
                                                >
                                                    Callout Details
                                                </Button>
                                            </div>
                                        </Col>
                                        <Col>
                                            <Row style={{ marginTop: 30, marginBottom: 10 }}>
                                                <Col span={12}>
                                                    <div style={{
                                                        display: 'flex',
                                                        width: '100%',
                                                        height: '10px',
                                                        backgroundColor: '#bdc3c7', // Default Pending color
                                                        borderRadius: '4px',
                                                        overflow: 'hidden'
                                                    }}>
                                                        {/* Successful Segment (Green) */}
                                                        <div style={{
                                                            width: row.stats.completed ? row.stats.total > 0 ? `${(row.stats.completed / row.stats.total) * 100}%` : "0%" : "0%",
                                                            backgroundColor: '#72c424'
                                                        }} />
                                                        {/* Failed Segment (Orange) */}
                                                        <div style={{
                                                            width: row.stats ? row.stats.total > 0 ? `${(row.stats.pending / row.stats.total) * 100}%` : "0%" : "0%",
                                                            backgroundColor: '#ed4f27'
                                                        }} />

                                                        {/* The remaining space automatically shows the background (Pending/Grey) */}
                                                    </div>
                                                    <Col span={10} style={{ textAlign: "center" }}>
                                                        <span style={{ color: '#72c424', fontSize: 10 }}>●</span> {row.stats ? row.stats.completed : 0} Successful {row.stats ? row.stats.total > 0 ? Math.round(((row.stats.completed / row.stats.total) * 100)) + "%" : "0%" : "0%"}
                                                    </Col>
                                                    <Col span={10} style={{ textAlign: "center" }}>
                                                        <span style={{ color: '#ed4f27', fontSize: 10 }}>●</span> {row.stats ? row.stats.pending : 0} Pending {row.stats ? row.stats.total > 0 ? Math.round(((row.stats.pending / row.stats.total) * 100)) + "%" : "0%" : "0%"}
                                                    </Col>

                                                    <Row style={{ marginTop: 10 }}>
                                                        <Col span={24}>
                                                            <div
                                                                style={{
                                                                    fontSize: 12,
                                                                    color: "#666",
                                                                    textAlign: "left",
                                                                }}
                                                            >
                                                                {
                                                                    row.packages &&
                                                                        row.packages.length &&
                                                                        row.packages[0].callout_created_at &&
                                                                        row.packages[0].callout_remarks
                                                                        ? (
                                                                            <span>
                                                                                <b>Latest Callout:</b> {row.packages[0].callout_created_at}{" "}
                                                                                {row.packages[0].callout_remarks}
                                                                            </span>
                                                                        )
                                                                        : null}
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                {/* Checkout */}
                                                <Col span={3}>
                                                    <div style={{ fontSize: 12 }}>
                                                        Created At:
                                                        <br />
                                                        <b>{row.packages[0].log_created_at}</b>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card>

                            </Card>
                        ))}{isFetching && (
                            <div style={{ textAlign: 'center', padding: 20 }}>
                                Loading more deliveries...
                            </div>
                        )}
                        <Modal
                            title="Dispatch Details"
                            visible={this.state.runsheetModalVisible}
                            onCancel={this.closeRunsheetModal}
                            footer={null}
                            width={1200}
                        >
                            {this.state.runsheetData && (
                                <>
                                    <Row gutter={16} style={{ marginBottom: 20 }}>
                                        <Col span={6}>
                                            <Statistic
                                                title="Successful"
                                                value={this.state.runsheetData.stats.delivery_successful}
                                            />
                                        </Col>

                                        <Col span={6}>
                                            <Statistic
                                                title="Pengding"
                                                value={this.state.runsheetData.stats.pending}
                                            />
                                        </Col>
                                        <Col span={6}>
                                            <Statistic
                                                title="Total TN's"
                                                value={this.state.runsheetData.stats.total}
                                            />
                                        </Col>
                                        <Col span={6}>
                                            <Statistic
                                                title="Total CWT"
                                                value={this.state.runsheetData.stats.total_cwt}
                                            />
                                        </Col>
                                    </Row>
                                    <Table
                                        rowKey="dh_id"
                                        dataSource={this.state.runsheetData.packages}
                                        pagination={false}
                                        size="small"
                                        scroll={{ x: "max-content" }}
                                        columns={[
                                            {
                                                title: "DM",
                                                dataIndex: "dh_id",
                                                render: (value, row, index) => {
                                                    const data = this.state.runsheetData.packages;
                                                    if (index > 0 && data[index - 1].dh_id === value) {
                                                        return "";
                                                    }
                                                    return value;
                                                }
                                            },
                                            {
                                                title: "Tracking",
                                                dataIndex: "tracking_number",
                                            },
                                            {
                                                title: "Destination",
                                                dataIndex: "destination",
                                            },
                                            {
                                            title: "Status",
                                            dataIndex: "package_status",
                                            render: (status) => {
                                                const statuses = [
                                                    "forwarded_to_branch",
                                                    "accepted_to_branch",
                                                    "forwarded_to_warehouse",
                                                    "accepted_to_warehouse"
                                                ];

                                                if (!statuses.includes(status)) {
                                                    return <Tag>{status}</Tag>;
                                                }

                                                const colors = {
                                                    forwarded_to_branch: "#1890ff",
                                                    accepted_to_branch: "#52c41a",
                                                    forwarded_to_warehouse: "#722ed1",
                                                    accepted_to_warehouse: "#fa8c16",
                                                };

                                                return (
                                                    <Tag color={colors[status]}>
                                                        {status}
                                                    </Tag>
                                                );
                                            },
                                        },
                                            {
                                                title: "Reference Code",
                                                dataIndex: "log_reference_code",
                                                responsive: ["sm"],
                                            },
                                            {
                                                title: "Remarks",
                                                dataIndex: "remarks",
                                                responsive: ["sm"],
                                            },
                                            {
                                                title: "Updated",
                                                dataIndex: "updated_at",
                                                responsive: ["sm"],
                                            },
                                        ]}
                                    />
                                </>
                            )}
                        </Modal>
                        <Modal
                            title="Package Documents"
                            visible={this.state.documentsModalVisible}
                            onCancel={this.closeDocumentsModal}
                            footer={null}
                            width={800}
                        >
                            <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
                                {this.state.selectedDocuments.map((doc, idx) => (
                                    <div key={idx} style={{ width: "30%", textAlign: "center" }}>
                                        <img
                                            src={doc.url}
                                            alt={`Document ${idx + 1}`}
                                            style={{ width: "100%", borderRadius: 4, marginBottom: 5 }}
                                        />
                                        <a href={doc.url} target="_blank" rel="noopener noreferrer">
                                            Open
                                        </a>
                                    </div>
                                ))}
                            </div>

                            {/* Footer */}
                            <div
                                style={{
                                    marginTop: 20,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "flex-end",
                                    gap: 10,
                                    borderTop: "1px solid #f0f0f0",
                                    paddingTop: 15
                                }}
                            >
                                {/* Editable Text Input */}
                                <input
                                    type="text"
                                    placeholder="Enter note"
                                    value={this.state.packageDocumentNote || ""}
                                    onChange={(e) => this.setState({ packageDocumentNote: e.target.value })}
                                    style={{
                                        padding: "6px 12px",
                                        borderRadius: 4,
                                        border: "1px solid #d9d9d9",
                                        flexGrow: 1,
                                        maxWidth: 300
                                    }}
                                />

                                <button
                                    style={{
                                        padding: "6px 16px",
                                        borderRadius: 4,
                                        border: "1px solid #d9d9d9",
                                        background: "#fff",
                                        cursor: "pointer"
                                    }}
                                    onClick={() =>
                                        this.setPackageValidity("Invalid EPODs", this.state.packageDocumentNote)
                                    }
                                >
                                    Invalid
                                </button>

                                <button
                                    style={{
                                        padding: "6px 16px",
                                        borderRadius: 4,
                                        border: "none",
                                        background: "#1890ff",
                                        color: "#fff",
                                        cursor: "pointer"
                                    }}
                                    onClick={() =>
                                        this.setPackageValidity("Valid EPODs", this.state.packageDocumentNote)
                                    }
                                >
                                    Valid
                                </button>
                            </div>
                        </Modal>
                        <Modal
                            title="Warning!"
                            visible={this.state.noDocumentsShow}
                            onCancel={this.closeNoDocuments}
                            footer={null}

                        >
                            <p>No EPODS</p>
                        </Modal>
                        <Modal
                            title="Success!"
                            visible={this.state.showDocumentValiditySuccess}
                            onCancel={this.closeDocumentValiditySuccess}
                            footer={null}

                        >
                            <p>Validity has been setWindowDimensions</p>
                        </Modal>
                        <Modal
                            title="Callout Details"
                            visible={this.state.calloutDetailModalVisible}
                            onCancel={this.closeCalloutDetailModal}
                            footer={null}
                            width={1200}
                        >
                            {/* <Spin tip="Loading User Create..."> */}
                            <Form labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>
                                <Form.Item label="Remarks">
                                    <div style={{ display: "flex", alignItems: "center", width: "100%", gap: 12 }}>

                                        <div style={{ flex: 1 }}>
                                            <Input
                                                value={this.state.forIrRemark}
                                                onChange={e => this.setState({ forIrRemark: e.target.value })}
                                                placeholder="Enter remark"
                                            />
                                        </div>

                                        <Checkbox
                                            checked={this.state.isIr}
                                            onChange={e => this.setState({ isIr: e.target.checked })}
                                        >
                                            For IR
                                        </Checkbox>

                                        <Button type="danger" ghost size="small"
                                            onClick={() =>
                                                this.handleSaveIr(this.state.forIrRemark, this.state.isIr)
                                            }
                                        >
                                            Save
                                        </Button>

                                    </div>
                                </Form.Item>
                            </Form>
                            <ServerSideTable
                                key={this.state.currentFilters.dh_id}
                                data={callOutList.rows}
                                pages={callOutList.pages}
                                columns={[
                                    {
                                        Header: 'ID',
                                        accessor: 'id',
                                        width: 50,
                                        id: 'id',
                                    },
                                    {
                                        Header: 'DH ID',
                                        accessor: 'dh_id',
                                    },
                                    {
                                        Header: 'Driver Name',
                                        accessor: 'driver_name',
                                    },
                                    {
                                        Header: 'Mobile Number',
                                        accessor: 'contact_no',
                                    },
                                    {
                                        Header: 'Remarks',
                                        accessor: 'remarks',
                                    },
                                    {
                                        Header: 'For IR',
                                        accessor: 'is_ir',
                                        Cell: ({ value }) => (
                                            <span style={{ color: value === 1 ? 'green' : 'red' }}>
                                                {value === 1 ? 'True' : 'False'}
                                            </span>
                                        ),
                                    },
                                    {
                                        Header: 'Created By',
                                        accessor: 'created_by_name',
                                    },
                                    {
                                        Header: 'Created At',
                                        accessor: 'created_at',
                                    },
                                ]}
                                loading={isCallOutLoading}
                                loadingText="Fetching callout list. . ."
                                manual
                                onFetchData={this.onFetchCallOutData}
                            />
                            {/* </Spin> */}
                        </Modal>
                        {/* Custom Pagination Footer to replace the table footer */}
                        <div style={{ textAlign: 'center', marginTop: 20 }}>

                        </div>
                    </div>
                </Card>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    user: state.auth.user,
});

TransferPerformanceList.defaultProps = {
    isCustomerMerchantPickUp: false,
    isTransmittal: false,
};

TransferPerformanceList.propTypes = {
    form: PropTypes.oneOfType([PropTypes.object]).isRequired,
    dispatchExportName: PropTypes.string.isRequired,
    hasExport: PropTypes.bool.isRequired,
    user: PropTypes.oneOfType([PropTypes.object]).isRequired,
    isCustomerMerchantPickUp: PropTypes.bool,
    isTransmittal: PropTypes.bool,
    typeDispatch: PropTypes.string.isRequired,
    fetchText: PropTypes.string.isRequired,
    urlEndpoint: PropTypes.string.isRequired,
    transferListColumns: PropTypes.oneOfType([PropTypes.array]).isRequired,
    doFetchPickupList: PropTypes.func.isRequired,
    doFetchTransferPerformanceList: PropTypes.func.isRequired,
    doFetchOptions: PropTypes.func.isRequired,
    doFetchOptionsLike: PropTypes.func.isRequired,
    dosetPackageRemarks: PropTypes.func.isRequired,
    doFetchTransmittalList: PropTypes.func.isRequired,
    doDeleteDispatch: PropTypes.func.isRequired,
    doCreateTransferCallout: PropTypes.func.isRequired,
    doFetchTransferCallout: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
    doFetchPickupList: fetchPickupList,
    doFetchTransferPerformanceList: fetchTransferPerformanceList,
    doFetchOptions: fetchOptions,
    doFetchOptionsLike: fetchOptionsLike,
    dosetPackageRemarks: setPackageRemarks,
    doFetchTransmittalList: fetchTransmittalList,
    doDeleteDispatch: deleteDispatch,
    doCreateTransferCallout: createTransferCallout,
    doFetchTransferCallout: fetchTransferCallout,
};

export default connect(mapStateToProps, mapDispatchToProps)(TransferPerformanceList);
